module.exports = __webpack_public_path__ + "static/media/hand-write-text.b23a5c6d.png";